import type {
  FetchETSTicketCommentsResponseData,
  FetchETSTicketNotificationsResponseData,
} from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import TicketCommentContent from 'gcs-common/components/Tickets/TicketComments/TicketCommentContent/TicketCommentContent';
import { friendlyDateTime } from 'gcs-common/helper/dateHelper';
import { getCurrentUserId } from 'gcs-common/slices/currentUser/currentUserSelectors';
import moment from 'moment';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';
import TicketCommentDeleteModal from './TicketCommentDeleteModal/TicketCommentDeleteModal';
import TicketCommentNotification from './TicketCommentNotification/TicketCommentNotification';

interface TicketCommentProps {
  ticketId: string;
  comment: FetchETSTicketCommentsResponseData['comments'][number];
  ticketNotification: FetchETSTicketNotificationsResponseData['notifications'][number] | undefined;
}

const TicketComment = (props: TicketCommentProps) => {
  const { ticketId, comment, ticketNotification } = props;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const currentUserId = useSelector(getCurrentUserId);

  const canDelete = comment.authorId === currentUserId;

  const showNotification =
    ticketNotification &&
    moment(comment.updatedAt || comment.createdAt).isAfter(ticketNotification.lastViewedAt) &&
    !comment.fromBeem;

  return (
    <div className={styles.commentContainer}>
      <div className={styles.commentLeft}>
        <div className={styles.commentLeftContent}>
          <div className={styles.commentIcon} style={{ backgroundImage: `url(${comment.authorImageUrl})` }} />

          {showNotification && <TicketCommentNotification />}
        </div>
      </div>
      <div className={styles.commentRight}>
        <div className={styles.commentHeader}>
          <div>{comment.authorName}</div>
          <div className={styles.commentTimestamp}>{friendlyDateTime(comment.createdAt)}</div>
        </div>
        <div className={styles.commentContent}>
          <TicketCommentContent html={comment.html} />
        </div>
        {canDelete && (
          <div>
            <button type="button" className={styles.deleteButton} onClick={() => setShowDeleteModal(true)}>
              Löschen
            </button>

            {showDeleteModal && (
              <TicketCommentDeleteModal
                ticketId={ticketId}
                commentId={comment.id}
                onClose={() => setShowDeleteModal(false)}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TicketComment;
